export default "__VITE_ASSET__1871db9c__"